



















import Vue from 'vue';
import {
  Component, Inject, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import {
  KCardHeader, KCardHeaderBtn,
} from '@kasasa/fbase-components';
import QualificationOverrideCard from '@/components/qualificationoverride/QualificationOverrideCard.vue';
import QualificationOverrideManagerCard from '@/components/qualificationoverride/QualificationOverrideManagerCard.vue';

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    QualificationOverrideCard,
    QualificationOverrideManagerCard,
  },
})
export default class QualificationOverride extends Vue {
  fiId!: string;

  lastSavedOverrideTime: Date | null = null;

  headerItems: any = [{
    text: 'Rewards Processing',
    disabled: false,
    link: false,
  },
  {
    text: 'Qualification Override',
    disabled: true,
  }];

  isFiUser(): boolean {
    return this.$store.state.isFiUser;
  }

  onNewOverride() {
    // Forces refresh of override manager card when new override saved
    this.lastSavedOverrideTime = new Date();
  }
}
